export const URGENCY_OPTIONS = [
  {
    id: 'emergency',
    label: 'Emergency — I need help today',
    icon: '🔴',
    target: 'Same day',
    color: '#DC2626',
  },
  {
    id: 'urgent',
    label: 'Urgent — I need help this week',
    icon: '🟠',
    target: '24-48 hours',
    color: '#D97706',
  },
  {
    id: 'soon',
    label: 'Soon — within the next few weeks',
    icon: '🟡',
    target: '1 week',
    color: '#CA8A04',
  },
  {
    id: 'planning',
    label: 'Planning ahead — no rush',
    icon: '🟢',
    target: '1-2 weeks',
    color: '#059669',
  },
] as const;
